import airtableProvider from "../../providers/prod/airtable";
import {
	AddOn,
	AddOnPermissionType,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	SettingsConfig,
	SettingsConfigType,
	UsageStats,
	UsageStatsType,
} from "../../../../index";
import googleDriveProvider from "../../providers/prod/googleDrive";
import dropboxProvider from "../../providers/prod/dropbox";

const a005AddOn = new AddOn({
	internalId: "a005",
	externalId: "pro_01j30ketb5t9fvdcrdqmxfpkf3",
	shortName: "Cloud sync files",
	longName: "Cloud sync files",
	shortDescription: "Sync files between services",
	longDescription: "* WIP",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a005/icons/a005_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a005/assets/background1.png"
	),
	previewAssets: [
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a004/screenshots/a004_screenshot_1.png"
		),
	],
	docsUrl:
		"https://docs.version2.io/articles/airtable-upload-attachments-bae920-1c797",
	providersIds: [
		airtableProvider._.id,
		googleDriveProvider._.id,
		dropboxProvider._.id,
	],
	status: AddOnStatus.ACTIVE,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a005_p001",
			externalId: "pri_01j30kk9hp826d1716z8wew9pt",
			prices: [new Price({ currency: Currency.USD, amount: 56 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a005_p002",
			externalId: "pri_01j30kjh41r9x04xswd4xfqymk",
			prices: [new Price({ currency: Currency.USD, amount: 8 })],
		}),
	],
	usageStats: [
		new UsageStats({
			id: "remote_bytes",
			name: "Remote bytes",
			description: "The total number of bytes uploaded to the remote server.",
			type: UsageStatsType.BYTES,
			max: 1073741824,
		}),
		new UsageStats({
			id: "remote_files",
			name: "Remote files",
			description: "The total number of files uploaded to the remote server.",
			type: UsageStatsType.FILES,
		}),
	],
	settingsConfig: [
		new SettingsConfig({
			id: "destination",
			label: "Destination service",
			description: "Choose the service where you want to sync the files to.",
			type: SettingsConfigType.INTEGRATION,
			validators: "google",
		}),
		new SettingsConfig({
			id: "google_picker",
			label: "Google Picker",
			description: "Select a Google Drive folder to sync the files to.",
			type: SettingsConfigType.GOOGLE_PICKER,
			validators: "google",
		}),
	],
	highlightFeatures: [
		new HighlightFeature({
			title: "Any file type",
			description:
				"Works with any file type and for multiple attachments in a single cell.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/file-text.svg",
		}),
		new HighlightFeature({
			title: "Live preview",
			description: "Preview the files files before uploading them.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
		}),
		new HighlightFeature({
			title: "Advanced filters",
			description:
				"Use advanced filters to group attachments by folder and more.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
		}),
	],
	allowedPermissionTypes: [
		AddOnPermissionType.AIRTABLE_ACCOUNT,
		AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE,
		AddOnPermissionType.AIRTABLE_BASE,
		AddOnPermissionType.AIRTABLE_SHARED,
	],
});

export default a005AddOn;
